import { state, mutations } from './state';
import actions from './actions';
import getters from './getters';

export const certificateModule = {
  state,
  mutations,
  actions,
  getters,
};

export default certificateModule;
